import { render, staticRenderFns } from "./select-vacancy.vue?vue&type=template&id=571bd10c&"
import script from "./select-vacancy.vue?vue&type=script&lang=js&"
export * from "./select-vacancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports